// extracted by mini-css-extract-plugin
module.exports = {"mainWrap":"Main_mainWrap__3ecLA","enterButton":"Main_enterButton__jUrie"};